module.exports = __webpack_public_path__ + "static/img/14.003b226.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/14.jpg
// module id = rLME
// module chunks = 5